module.exports = __webpack_public_path__ + "static/media/view other certificate.7b80f12d.svg";